/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Map_UnsupportedInputs */



/**
* | output |
* | --- |
* | "The map needs a newer browser." |
*
* @param {Services_Map_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_map_unsupported = /** @type {((inputs?: Services_Map_UnsupportedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Map_UnsupportedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("地图需要更新版本的浏览器。")
	return /** @type {LocalizedString} */ ("The map needs a newer browser.")
});